
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_3skry_145",
  "scrolling-background": "awsui_scrolling-background_hyvsj_3skry_148",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_3skry_159",
  "drawers-container": "awsui_drawers-container_hyvsj_3skry_172",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_3skry_183",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_3skry_204",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_3skry_209",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_3skry_250",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_3skry_260",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_3skry_265",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_3skry_279",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_3skry_265",
  "drawer": "awsui_drawer_hyvsj_3skry_172",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_3skry_310",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_3skry_319",
  "drawer-content": "awsui_drawer-content_hyvsj_3skry_310",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_3skry_328",
  "drawer-slider": "awsui_drawer-slider_hyvsj_3skry_331",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_3skry_338",
  "content": "awsui_content_hyvsj_3skry_364",
  "layout": "awsui_layout_hyvsj_3skry_389",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_3skry_461",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_3skry_476",
  "content-type-table": "awsui_content-type-table_hyvsj_3skry_490",
  "content-type-cards": "awsui_content-type-cards_hyvsj_3skry_490",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_3skry_496",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_3skry_499",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_3skry_513",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_3skry_516",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_3skry_526",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_3skry_529",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_3skry_529",
  "has-header": "awsui_has-header_hyvsj_3skry_529",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_3skry_544",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_3skry_544",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_3skry_564",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_3skry_567",
  "has-split-panel": "awsui_has-split-panel_hyvsj_3skry_587",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_3skry_587",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_3skry_595",
  "unfocusable": "awsui_unfocusable_hyvsj_3skry_600",
  "container": "awsui_container_hyvsj_3skry_610",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_3skry_636",
  "is-tools-open": "awsui_is-tools-open_hyvsj_3skry_639",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_3skry_639",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_3skry_639",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_3skry_639",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_3skry_652",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_3skry_669",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_3skry_673",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_3skry_677",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_3skry_681",
  "navigation-container": "awsui_navigation-container_hyvsj_3skry_690",
  "show-navigation": "awsui_show-navigation_hyvsj_3skry_728",
  "animating": "awsui_animating_hyvsj_3skry_751",
  "showButtons": "awsui_showButtons_hyvsj_3skry_1",
  "navigation": "awsui_navigation_hyvsj_3skry_690",
  "openNavigation": "awsui_openNavigation_hyvsj_3skry_1",
  "animated-content": "awsui_animated-content_hyvsj_3skry_815",
  "content-container": "awsui_content-container_hyvsj_3skry_818",
  "hide-navigation": "awsui_hide-navigation_hyvsj_3skry_827",
  "notifications": "awsui_notifications_hyvsj_3skry_837",
  "has-notification-content": "awsui_has-notification-content_hyvsj_3skry_842",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_3skry_846",
  "high-contrast": "awsui_high-contrast_hyvsj_3skry_851",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_3skry_869",
  "position-bottom": "awsui_position-bottom_hyvsj_3skry_916",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_3skry_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_3skry_945",
  "position-side": "awsui_position-side_hyvsj_3skry_958",
  "tools-container": "awsui_tools-container_hyvsj_3skry_980",
  "tools": "awsui_tools_hyvsj_3skry_980",
  "openTools": "awsui_openTools_hyvsj_3skry_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_3skry_1069",
  "hide-tools": "awsui_hide-tools_hyvsj_3skry_1079",
  "show-tools": "awsui_show-tools_hyvsj_3skry_1091",
  "has-tools-form": "awsui_has-tools-form_hyvsj_3skry_1069",
  "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_3skry_1174",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_3skry_1190",
  "trigger": "awsui_trigger_hyvsj_3skry_1174",
  "selected": "awsui_selected_hyvsj_3skry_1242",
  "badge": "awsui_badge_hyvsj_3skry_1262",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_3skry_1266",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_3skry_1277",
  "dot": "awsui_dot_hyvsj_3skry_1281",
  "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_3skry_1294"
};
  